import * as React from "react";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { useContextData } from "../hooks/useContextData";

const emails = ["username@gmail.com", "user02@gmail.com"];

export interface SimpleDialogProps {
  open: boolean;
  selectedValue: string;
  onClose: (value: string) => void;
}

function SimpleDialog(props: SimpleDialogProps) {
  const { onClose, selectedValue, open } = props;
  const { theme } = useContextData();

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value: string) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <div
        style={{
          backgroundColor: theme === "dark" ? "#00050F" : "white",
          color: theme === "dark" ? "#FAFAFA" : undefined,
        }}
      >
        <DialogTitle textAlign={"center"}>Purchase Successful!</DialogTitle>
        <List sx={{ pt: 0, px: 3, pb: 3 }}>
          <Typography variant="body1" gutterBottom>
            Thank you for your purchase. Your search tokens have been added to
            your account.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            You can now return to the search page and use your tokens.
          </Typography>
          <Button
            variant="contained"
            fullWidth
            onClick={handleClose}
            sx={{ mt: 1 }}
            color="success"
          >
            Continue
          </Button>
        </List>
      </div>
    </Dialog>
  );
}

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function AfterPurchase({ open, setOpen }: Props) {
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value: string) => {
    setOpen(false);
    setSelectedValue(value);
  };

  return (
    <div>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
      />
    </div>
  );
}
